/**
 * @desc 查询BindingLog分页列表
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.PageRequest<defs.PhysicalOilCardBindingQueryParameters>): Promise<BaseResponse<defs.PageBean<Array<defs.ResPhysicalBindingLog>>>> {
  return fetch({
    url: config.API_HOST + '/shitiCard/yuTu/bindLogPageList',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
